import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/login_new.jpg'


const Login = () => {
  const [phone, setPhone] = useState(''); // State for phone number
  const [password, setPassword] = useState(''); // State for password
  const [showResendButton, setShowResendButton] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [otpworld1, setOtpworld1] = useState(false);
  const [otpworld2, setOtpworld2] = useState(false);
  const [confirmObj, setConfirmObj] = useState("");
  const navigate = useNavigate();
  const [load, setLoad] = useState(true);
  const [data, setData] = useState({
    email: '',
    password: '',
  })
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };



  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log('Login data:', data)
    setLoad(false)

    // Add your login logic here, such as making an API call
    if (phone && password) {
      const response = await fetch(`${process.env.REACT_APP_LINK}/auth/login`, {
        method: "POST",
        // credentials:"include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username: phone,
          password: password
        })
      })
      const res = await response.json();
      console.log(res);
      if (response.ok) {
        console.log(res);
        localStorage.setItem('2xgxgshdugyywerw12gh', JSON.stringify(res.users));
        navigate("/")
        toast.success('Login Successful')
        setLoad(true)
      }else if (response.status===400){
        toast.warning(res.message)
        setLoad(true)
      }
      setLoad(true)
    } else {
      setLoad(true)
      alert('Please enter both email and password')
    }
  }





  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      {/* <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}> */}
      <div className="login-bg">
        <div className="login-img">
          <img src={loginImg} alt="" />
        </div>
        <div className="login-box">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="phone"
              placeholder="Email"
              value={phone}
              onChange={handlePhoneChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
            />
            <p className="register">
              By continuing, I agree to the <Link to='https://100billiontech.com/terms-and-conditions'>Terms of use</Link> & <Link to='https://100billiontech.com/privacy-policy'>Privacy Policy</Link>
            </p>
            {
              load ? <button type="submit">Continue</button> :
                <button type="button" disabled>Loading...</button>
            }

          </form>
          {/* <p className="divider">Or sign in with</p>
                    <div className="google">
                        Sign in with Google
                    </div> */}
          {/* <p className="register">
            Don't have an account? <Link to='/register'>Register now</Link>
          </p> */}
          <Link to='/reset' style={{ textDecoration: "none" }}><p className="reset-btn">Having trouble in sign in?</p></Link>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default Login;
